import {
	Component,
	OnInit,
	Input,
	ElementRef,
	AfterViewInit,
	DoCheck,
	AfterContentInit
} from "@angular/core";
import { DebugService } from "../../../app/_core/services/debug.service";

@Component({
    selector: "dodo-cta-pointer",
    templateUrl: "./cta-pointer.component.html",
    styleUrls: ["./cta-pointer.component.scss"],
    standalone: false
})
export class CtaPointerComponent implements OnInit, DoCheck {
	@Input() totalStops: number;
	@Input() pointerSize = 20;
	@Input() backgroundColor: string;
	@Input() pointAtStopeNumber: number;

	public containerHeight: number;
	public pointerDiag: number;

	private width: number;
	private __element: HTMLElement;

	constructor(private er: ElementRef, private log: DebugService) {
		this.__element = <HTMLElement>this.er.nativeElement;
		this.pointerDiag = Math.sqrt(
			Math.pow(this.pointerSize, 2) + Math.pow(this.pointerSize, 2)
		);
		this.containerHeight = this.pointerDiag / 2 + 1;
	}

	ngDoCheck() {
		this.width = this.__element.offsetWidth;
	}

	ngOnInit() {
		if (!this.backgroundColor) {
			this.backgroundColor = "#F0F2F5";
		}
	}

	public get pointerPosition(): number {
		if (this.pointAtStopeNumber >= 0 && this.totalStops >= 0) {
			return (
				(this.pointAtStopeNumber + 0.5) *
					(this.width / this.totalStops) -
				14.14
			);
		} else {
			return -100;
		}
	}

	public get pointerTransform(): string {
		return "rotate(45Deg) translate(" + (this.pointerSize / 10) * 3 + "px)";
	}
}
